<template>
  <div class="report">
    <div class="content">
      <div class="flex btn_wrap">
        <div class="btn_primary" @click="goProduct3"><i class="icon icon_man"></i>专家服务</div>
        <div class="btn_plain" @click="goBack"><i class="icon icon_return"></i>返回</div>
      </div>
      <div class="bg">
        <span class="wrap">
          <h3>网站安全检测报告</h3>
          <p>{{hostName}}</p>
        </span>
      </div>
      <!--综述：-->
      <div class="block sum flex_between">
        <div class="txt_wrap">
          <h4>综述</h4>
          <p v-if="stats != null"> 本次任务共检测主机 1 个，域名 1 个，风险总数 {{statsItems.total}} 个（另有信息级风险 {{stats['cnt_I']}}
            个），安全风险总评级为<b :class="{'color_c':statsItems.level=='紧急','color_h':statsItems.level=='高风险','color_m':statsItems.level=='中风险','color_l':statsItems.level=='低风险','color_i':statsItems.level=='一般'}">{{statsItems.level}}</b>。
            高风险及以上风险总数 {{statsItems.highRiskCount}} 个，其中主机漏洞 {{stats['count_by_type']['host']}} 个，占比 {{statsItems.total == 0?0:((100 * stats['count_by_type']['host']/statsItems.total).toFixed(2))}}% ，Web漏洞
            {{stats['count_by_type']['web']}} 个，占比 {{statsItems.total == 0?0:((100 *
            stats['count_by_type']['web']/statsItems.total).toFixed(2))}}% ，弱密码 {{stats['count_by_type']['weak']}} 个。
          </p>
          <p v-else>暂无数据</p>
        </div>
        <i :class="{'iconm':true,'icon_c':statsItems.level=='紧急','icon_h':statsItems.level=='高风险','icon_m':statsItems.level=='中风险','icon_l':statsItems.level=='低风险','icon_i':statsItems.level=='一般'}"></i>
      </div>
      <!--3:各种图-->
      <div class="block bugMap flex_between">
        <div class="bugItem bugType">
          <h3>漏洞类型</h3>
          <el-radio-group v-model="tabType" @change="radioClick">
            <ul class="ul_type flex_between">
              <li class="item1">
                <span class="wrap_check"><el-radio label="host_vul" :checked=true></el-radio></span>
                <span class="icon_bg"></span>
              </li>
              <li class="item2">
                <span class="wrap_check"><el-radio label="web_vul"></el-radio></span>
                <span class="icon_bg"></span>
              </li>
              <li class="item3">
                <span class="wrap_check"><el-radio label="weak_vul"></el-radio></span>
                <span class="icon_bg"></span>
              </li>
            </ul>
          </el-radio-group>
        </div>
        <div class="bugItem bugLevel">
          <h3>漏洞等级</h3>
          <el-checkbox-group class="check_bugLevel" v-model="checkGroup_bugLevel" size="small" @change="checkChange">
            <div class="flex_between wrap">
              <el-checkbox :checked=true label="紧急f" border>紧急</el-checkbox>
              <el-checkbox :checked=true label="备选项2" border>高危</el-checkbox>
              <el-checkbox :checked=true label="备选项3" border>中危</el-checkbox>
            </div>
            <div class="flex_between wrap wrap2">
              <el-checkbox :checked=true label="备选项4" border>低危</el-checkbox>
              <el-checkbox :checked=true label="备选项5" border>一般</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <!--图：-->
        <div class="bugItem bugStat">
          <h3>漏洞统计/个</h3>
          <div id="domainsStatistics" ref="domainsStatistics"></div>
        </div>
      </div>
      <!--4:手风琴-->
      <div class="block bugAccording">
        <p class="block-title"> 漏洞类型 <span>漏洞等级</span></p>
        <div class="block-collapse" v-if="isShow">
          <el-collapse accordion v-model="activeNames" @change="handleChange">
            <el-collapse-item :name="item.id" v-for="item in vulList" :key="item.id">
              <template slot="title">
                <span class="accTitle">{{item.name}}</span>
                <span :class="{'domainLevel':true,'level-C':item.level=='C','level-H':item.level=='H','level-M':item.level=='M','level-L':item.level=='L','level-I':item.level=='I'}">{{{C:'紧急',H:'高危',M:'中危',L:'低危',I:'一般'}[item.level]}}</span>
              </template>

              <span >
                <div class="block-item">
                  <p class="collapse-title">漏洞描述</p>
                  <div class="block-cont">{{accordingDatailList.desc == '' ? '暂无':accordingDatailList.desc}}</div>
                </div>
                <div class="block-item">
                    <p class="collapse-title">解决方案</p>
                    <div class="block-cont">{{accordingDatailList.solution}}</div>
                  </div>
                  <div class="block-item">
                  <p class="collapse-title">目标列表</p>
                  <div class="block-cont">{{accordingDatailList.ip}}</div>
                </div>
              </span>
            </el-collapse-item>
          </el-collapse>
        </div>
        <h3 v-else style="margin:30px;">暂无数据</h3>
      </div>
      <!--&lt;!&ndash;5：分页&ndash;&gt;
      <div class="page_bar">
        <el-pagination class="paginationBar" background layout="prev, pager, next" :total="50"></el-pagination>
      </div>-->
    </div>
    <!--footer-->
    <footBar style="height:160px;"></footBar>
    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import {vul_stats, vul_list, vul_detail} from '../api/api'
  import footBar from '../components/footerbar'
  import returnTop from '../components/returnTop'

  export default {
    name: "scanReport",
    components: {footBar, returnTop},
    data() {
      return {
        hostName:'',
        isShow:true,
        stats: {cnt_C: 0, cnt_H: 0, cnt_I: 0, cnt_L: 0, cnt_M: 0, count_by_type: {host: 0, weak: 0, web: 0,}},
        accordingDatailList: {},
        vulList: [],
        tabType: 'host_vul',
        checkGroup_bugLevel: [],
        activeNames: [],//
      }
    },
    mounted() {
      this.hostName = decodeURI(this.$route.query.hostName);
      this.fetchData();
    },
    methods: {
      fetchData() {
        var vm = this;
        let params1 = {site_id: this.$route.query.id,};
        vul_stats(params1).then(res => {//摘要
          if (res.data.code == 1 && res.data.data) {
            vm.stats = res.data.data;
            let replaceList = {
              cnt_C: vm.stats['cnt_C'],
              cnt_H: vm.stats['cnt_H'],
              cnt_M: vm.stats['cnt_M'],
              cnt_L: vm.stats['cnt_L'],
              cnt_I: vm.stats['cnt_I']
            }
            let nameList = [];
            let valList = [];
            for (let i in replaceList) {
              nameList.push(i);
              valList.push(replaceList[i]);
            }
            for (let i in nameList) {
              if (nameList[i] == "cnt_C") {
                nameList[i] = "紧急"
              }
              if (nameList[i] == "cnt_H") {
                nameList[i] = "高危"
              }
              if (nameList[i] == "cnt_M") {
                nameList[i] = "中危"
              }
              if (nameList[i] == "cnt_L") {
                nameList[i] = "低危"
              }
              if (nameList[i] == "cnt_I") {
                nameList[i] = "一般"
              }
            }
            this.drawDomainsStatistics(nameList, valList);
          }
        });
        let params2 = {
          site_id: this.$route.query.id,
          vul_type: this.tabType,
        };
        vul_list(params2).then(res => {//漏洞列表
          this.vulList = res.data.data;
          if((res.data.data).length == 0){
            this.isShow = false;
          }else{
            this.isShow = true;
          }
        });
      },
      handleChange(val) {//手风琴改变
        let params3 = {
          site_id: this.$route.query.id,
          vul_type: this.tabType,
          vul_id: val,
        };
        vul_detail(params3).then(res => {//漏洞详情
          this.accordingDatailList = res.data.data;
          //console.log('res',res);
        })
      },
      drawDomainsStatistics(x, y) {
        let domainsStatistics = this.$refs.domainsStatistics;
        let myChart_domainsStatistics = this.$echarts.init(domainsStatistics);
        // 指定图表的配置项和数据
        let option_domainsStatistics = {
          grid: {
            top: '10%',
            left: '2%',
            right: '4%',
            bottom: '0%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          xAxis: [
            {
              type: 'category',
              data: x,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {//周内网格线
                show: true, lineStyle: {type: 'dashed', color: '#717179'}
              },
            }
          ],
          series: [
            {
              name: '漏洞个数',
              type: 'bar',
              barWidth: '40%',
              itemStyle: {
                normal: {
                  color: function (params) {
                    var colorList = ['#8C29C5', '#E14646', '#F39C39', '#2168C5', '#40966A']
                    return colorList[params.dataIndex]
                  }
                }
              },
              data: y,
            }
          ]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart_domainsStatistics.setOption(option_domainsStatistics);
      },
      checkChange() {//漏洞等级
        console.log('ddd', this.checkGroup_bugLevel);
      },
      radioClick() {//漏洞类型筛选
        let params2 = {
          site_id: this.$route.query.id,
          vul_type: this.tabType,
        };
        vul_list(params2).then(res => {//漏洞列表
          this.vulList = res.data.data;
          if((res.data.data).length == 0){
            this.isShow = false;
          }else{
            this.isShow = true;
          }
        });

      },
      goBack() {
        // this.$router.go(-1);
        this.$router.push('/mySite');
      },

      goProduct3() {
        this.$router.push('/product3');
      },
    },
    computed: {
      statsItems: function () {
        console.log(this.stats)

        let total = this.stats['cnt_C'] + this.stats['cnt_H'] + this.stats['cnt_M'] + this.stats['cnt_L'] + this.stats['cnt_I'];
        let tmp = {'cnt_C': '紧急', 'cnt_H': '高风险', 'cnt_M': '中风险', 'cnt_L': '低风险', 'cnt_I': '一般'}
        let level = '一般'
        Object.keys(tmp).forEach(key => {
          if (this.stats[key] && this.stats[key] > 0 && level == '一般') {
            level = tmp[key]
          }
        });
        let highRiskCount = this.stats['cnt_C'] + this.stats['cnt_H'];
        return {total, highRiskCount, level}
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/scanReport.vue